export default __webpack_public_path__ + "static/Tranq_Arrow-27520986a1d7f3b71d927bc8899c6c9e.png";